import React, { useState } from 'react';

import { AlertBox, Icon, Modal } from '@iwoca/orion';

import styles from './PayLinkStatusModal.module.css';

export const PayLinkStatusModal = () => {
  const [showStatuses, setShowStatuses] = useState<boolean>(false);
  return (
    <>
      <button
        className={styles.showStatusModalButton}
        onClick={() => setShowStatuses(!showStatuses)}
      >
        What are the statuses?
      </button>
      <Modal
        closeIcon
        id="modal_id"
        isOpen={showStatuses}
        onClose={() => {
          setShowStatuses(false);
        }}
        subTitle="This is the journey that your customers will go through when applying for iwocaPay."
        title="Paylink statuses"
        className={styles.payLinkModal}
      >
        <div className={styles.payLinkModalExplanation}>
          <div>
            <h3>Not started</h3>
            <p>
              Your customer has clicked to pay with iwocaPay, but hasn’t yet
              entered their email address and started their application.
            </p>
          </div>
          <div>
            <h3>Started</h3>
            <p>
              The customer has entered their email address and started their
              application. They haven’t yet submitted their information.
            </p>
          </div>
          <div>
            <h3>Offered</h3>
            <p>
              The customer’s application has been accepted and they need to
              complete our security checks.
            </p>
          </div>
          <div>
            <h3>You've been paid 🙌</h3>
            <p>
              The customer has completed the process and we’ve sent the funds to
              your account.
            </p>
          </div>

          <div className={styles.smallInfo}>
            <Icon icon="infoCircleOutline" className={styles.infoIcon} />
            <div>We can’t contact the customer yet</div>
          </div>
          <div className={styles.smallInfo}>
            <Icon icon="infoCircleOutline" className={styles.infoIcon} />
            <div>We have their email address</div>
          </div>
          <div className={styles.smallInfo}>
            <Icon icon="infoCircleOutline" className={styles.infoIcon} />
            <div>We can call them or email them</div>
          </div>
        </div>
        <AlertBox variant={'connect'} className={styles.statusesAlert}>
          <Icon icon="infoCircleOutline" className={styles.statusIcon} />
          <div className={styles.statusesText}>
            <strong>Please note:</strong> - At all stages, whilst we might be
            able to contact the customer, please continue to encourage your
            customer to complete the process.
          </div>
        </AlertBox>
      </Modal>
    </>
  );
};
